import {
  CREATE_TOPICS_BEGIN,
  CREATE_TOPICS_SUCCESS,
  CREATE_TOPICS_FAILURE,
  UPDATE_TOPICS_BEGIN,
  UPDATE_TOPICS_SUCCESS,
  UPDATE_TOPICS_FAILURE,
  RESET_TOPICS_STATE,
  KEY_FOR_TOPIC_ID,
  KEY_FOR_TOPIC_NAME,
  KEY_FOR_CATEGORIES,
  KEY_FOR_DESCRIPTION,
  KEY_FOR_KEYWORDS_JSON,
  KEY_FOR_TOPIC_READY_NOTIFICATION_EMAIL_ADDRESS,
  KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE,
  KEY_FOR_ESTIMATED_PROCESSING_TIME_IN_HOURS,
  KEY_FOR_HAS_CRAWLED_DATA,
  KEY_FOR_HAS_UPLOADED_DATA
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';

export function createTopics(props = {}) {
  return dispatch => {
    dispatch({
      type: CREATE_TOPICS_BEGIN,
    });
    const url = `${apiEndPoints.topics.CREATE_TOPICS}`;
    const promise = new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append(KEY_FOR_TOPIC_NAME, props.topicName);
      formData.append(KEY_FOR_DESCRIPTION,props.description);
      formData.append(KEY_FOR_CATEGORIES,props.categories);
      formData.append(KEY_FOR_HAS_CRAWLED_DATA, props.hasCrawledData);
      formData.append(KEY_FOR_HAS_UPLOADED_DATA, props.hasUploadedData);
      if (props.hasCrawledData) { 
        formData.append(KEY_FOR_KEYWORDS_JSON,JSON.stringify(props.keywordsJSON));
        formData.append(KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE, props.earliestHistoricalDataDate);
      }
      if (props.topicReadyNotificationEmailAddress) {
        formData.append(KEY_FOR_TOPIC_READY_NOTIFICATION_EMAIL_ADDRESS, props.topicReadyNotificationEmailAddress)
      }
      if (props.estimatedProcessingTimeInHours) {
        formData.append(KEY_FOR_ESTIMATED_PROCESSING_TIME_IN_HOURS, props.estimatedProcessingTimeInHours);
      }
      const doRequest = http.post(url,formData);
      doRequest.then(
        res => {
          dispatch({
            type: CREATE_TOPICS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: CREATE_TOPICS_FAILURE,
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function resetTopicState() {
  return dispatch => {
    dispatch({
      type: RESET_TOPICS_STATE,
    });
  };
}

export function updateTopics(props = {}) {
  return dispatch => {
    dispatch({
      type: UPDATE_TOPICS_BEGIN,
    });
    const url = `${apiEndPoints.topics.UPDATE_TOPICS}`;

    const promise = new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append(KEY_FOR_TOPIC_ID, props.topicId);
      formData.append(KEY_FOR_TOPIC_NAME, props.topicName);
      formData.append(KEY_FOR_DESCRIPTION,props.description);
      formData.append(KEY_FOR_CATEGORIES,props.categories);
      if (props.keywordsJSON) {
        formData.append(KEY_FOR_KEYWORDS_JSON,JSON.stringify(props.keywordsJSON));
        formData.append(KEY_FOR_EARLIEST_HISTORICAL_DATA_DATE, props.earliestHistoricalDataDate);
      }
      if (props.topicReadyNotificationEmailAddress) {
        formData.append(KEY_FOR_TOPIC_READY_NOTIFICATION_EMAIL_ADDRESS, props.topicReadyNotificationEmailAddress)
      }
      if (props.estimatedProcessingTimeInHours) {
        formData.append(KEY_FOR_ESTIMATED_PROCESSING_TIME_IN_HOURS, props.estimatedProcessingTimeInHours);
      }
      const doRequest = http.patch(url, formData);
      doRequest.then(
        res => {
          dispatch({
            type: UPDATE_TOPICS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: UPDATE_TOPICS_FAILURE,
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CREATE_TOPICS_BEGIN:
      return {
        ...state,
        createTopicsBegin: true,
        createTopicsFailure: false,
        createTopicsSuccess: false,
        updateTopicsSuccess: false,
      };
    case CREATE_TOPICS_SUCCESS:
      state.allTopics.count = state.allTopics.count + 1;
      return {
        ...state,
        createTopicsBegin: false,
        createTopicsSuccess: true,
        createdTopicId: action.data.data.topicId,
      };
    case CREATE_TOPICS_FAILURE:
      return {
        ...state,
        createTopicsBegin: false,
        createTopicsFailure: true,
      };
    case UPDATE_TOPICS_BEGIN:
      return {
        ...state,
        updateTopicsBegin: true,
        updateTopicsSuccess: false,
        createTopicsSuccess: false,
      };
    case UPDATE_TOPICS_SUCCESS:
      return {
        ...state,
        updateTopicsSuccess: true,
        updateTopicsBegin: false,
        updateTopicsTopicProcessedState: action.data.data.topicProcessedState
      };
    case UPDATE_TOPICS_FAILURE:
      return {
        ...state,
        updateTopicsFailure: true,
        updateTopicsBegin: false,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/topics/redux/createTopic.js